import React, { FC } from 'react';
import Table from 'components/Table';
import { IColumn } from 'components/Table/types';

import { useAppDispatch } from 'store/hooks';

import { ReactComponent as ExportIcon } from 'assets/export.icon.svg';
import Action from 'components/Action';

import useStyles from './styles';
import { TableTypes } from 'components/Table/constants';
import { ThunkGetInvoiceFile } from 'store/invoices/thunks';
import { tt } from '@i18n/tt';

const Invoices: FC = () => {
  const classes = useStyles();
  const dispatch = useAppDispatch();

  const downloadInvoice = (invoiceId: number): void => {
    dispatch(ThunkGetInvoiceFile(invoiceId))
      .unwrap()
      .then(async res => {
        const blob = await res;
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'invoice.pdf');

        // Simulate click event on the link to trigger the download
        link.click();

        // Clean up
        window.URL.revokeObjectURL(url);
      });
  };

  const columns: IColumn[] = [
    {
      name: tt('pages.invoices.table.invoiceNumber'),
      key: 'invoiceNumber',
      searchable: true,
      sortable: true,
      width: 150,
    },
    {
      name: tt('pages.invoices.table.company'),
      key: 'companyName',
      searchable: true,
      sortable: true,
    },
    {
      name: tt('pages.invoices.table.date'),
      key: 'date',
      type: TableTypes.date,
      sortable: true,
    },
    {
      name: tt('pages.invoices.table.dueDate'),
      key: 'dueDate',
      type: TableTypes.date,
      sortable: true,
    },
    {
      name: tt('pages.invoices.table.status'),
      key: 'statusName',
      searchable: true,
      sortable: true,
    },
    {
      name: tt('pages.invoices.table.paid'),
      key: 'isPaid',
      width: 120,
      type: TableTypes.boolean,
    },
    {
      name: tt('pages.invoices.table.total'),
      key: 'total',
      width: 120,
      type: TableTypes.custom,
      accessor: i => (
        <>
          {i.currency.symbol}
          {i.total.toFixed(2)}
        </>
      ),
    },
    {
      name: tt('pages.invoices.table.actions'),
      width: 120,
      key: 'actions',
      type: TableTypes.custom,
      accessor: i => (
        <Action tooltip={tt('buttons.download')} onClick={() => { downloadInvoice(i.id) }} icon={<ExportIcon className={classes.downloadIcon} />} />
      ),
    },
  ];
  return (
    <div className={classes.container}>
      <Table resource={'ClientPortalInvoices/connectwise/invoices-for-company'} columns={columns} />
    </div>
  );
};

export default Invoices;
